const accessMapCircle = (() => {

  // const pageAccess = (document.getElementById("pageAccess") != null);
  const pageLocation = (document.getElementById("pageLocation") != null);
  // if (pageAccess || pageLocation) {
  if (pageLocation) {


    gsap.set([".location-map-wrap .circle",], {
      opacity: 0,
      scale: 0,
    });
    gsap.set([".min3", ".min5"], {
      opacity: 0,
    });

    let mapWrap = document.querySelectorAll('.location-map-wrap');
    let circle = document.querySelectorAll('.location-map-wrap .circle');

    gsap.to(circle, {
      opacity: 1,
      duration: 1,
      scale: 1,
      ease: "circ.inOut",
      scrollTrigger: {
        trigger: mapWrap,
        start: "0% 50%",
        // markers: true,
      },
      stagger: {
        from: "start",
        amount: 0.3,
      },
      onComplete: function() {
        // circleのアニメーションが完了した後に.min3と.min5のアニメーションを実行
        gsap.to(".min3", {
          opacity: 1,
          duration: 0.8,
        });
        gsap.to(".min5", {
          opacity: 1,
          duration: 0.8,
        },"<0.2");
      },
    });




  }

})();
export default accessMapCircle;